// import { PatientSchema } from '@/zod_schemas';
import { Box, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { CustomTabPanel, tabProps } from '../../Account/AccountPage';
import PatientHPO from './PatientHPO';
import PatientSamples from './PatientSamples';

const PatientDataForm = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        overflow: 'hidden',
        borderRadius: 2.5,
        bgcolor: 'background.paper',
      }}
    >
      <Stack spacing={0.25} sx={{ px: { xs: 2, md: 3 }, pt: 2 }}>
        <Typography variant="h3">Clinical associations</Typography>
        <Typography variant="body2" color="text.secondary">
          Link phenotypic terms and samples to support interpretation.
        </Typography>
      </Stack>
      <Box
        sx={{
          px: { xs: 2, md: 3 },
          pt: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={currentTab}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="HPO" {...tabProps(0)} />
          <Tab label="SAMPLES" {...tabProps(1)} />
        </Tabs>
      </Box>
      {/* Always render both panels but show only the active one */}
      <CustomTabPanel value={currentTab} index={0}>
        <PatientHPO />
      </CustomTabPanel>
      <CustomTabPanel value={currentTab} index={1}>
        <PatientSamples />
      </CustomTabPanel>
    </Paper>
  );
};

export default PatientDataForm;
